import React, { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MaterialTable from '@material-table/core';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton';
import mainStore from '../../../MainStore';
import Participants from './Participants';
import { observer } from 'mobx-react';

const ProjectProducts = observer(class ProjectProducts extends Component {
    constructor() {
        super();
        this.state = {
            projectInfo: {
                isCodeReviewOn: false,
                checkedA: 'checkedA',
                planHours: 0
            },
            columns: [
                { title: 'Продукт', field: 'productName' },
                { title: 'Версия продукта', field: 'productVersion' },
                { title: 'Тип SQL', field: 'sqlType' }
            ],
            products: [],
            sqlTypes: [],

            isAddProductOpen: false,
            rowData: {
                
            }

        };
        this.load = this.load.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleRowDataChange = this.handleRowDataChange.bind(this);
    };

    componentDidMount() {
        this.load();
    };

    componentDidUpdate(prevProps) {
        if (prevProps && prevProps.project.id !== this.props.project.id) {
            this.load();
        }
    };

    handleRowDataChange = name => evt => {
        var rowData = this.state.rowData;
        rowData[name] = evt.target.value;
        this.setState({ rowData: rowData });
    };

    handleChange = name => evt => {
        mainStore.openedProject[name] = evt.target.value;
        mainStore.setOpenedProject(mainStore.openedProject);
    };

    handleClose() {
        this.setState({ "isAddProductOpen": false });
    }

    load() {
        mainStore.setMaskVisible();
        var scope = this;
        var token = localStorage.getItem("token");

        fetch('api/Project/GetProjectProducts?id=' + this.props.project.id, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ "products": result });
                    mainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    };

    handleSave() {
        var scope = this;
        var token = localStorage.getItem("token");
        var data = this.state.rowData;
        data.projectId = this.props.project.id;
        fetch('api/Project/SaveProjectProduct', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    var products = scope.state.products.slice(0);
                    var index = products.findIndex(e => e.id === result.id);
                    if (index > -1) {
                        products[index] = result;
                    }
                    else {
                        products.push(result);
                    }
                    scope.setState({ products: products });
                    scope.handleClose();
                }).catch((err) => console.log(err));
            }
        });
    };

    deleteProduct(data, resolve) {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Project/DeleteProjectProduct', {
            method: 'POST',
            body: JSON.stringify(data.id),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    var products = scope.state.products.slice(0);
                    var index = products.findIndex(e => e.id === data.id);
                    if (index !== -1) products.splice(index, 1);
                    scope.setState({ products: products });
                    resolve();
                }).catch((err) => console.log(err));
            }
        });
    };

    render() {
        if (!this.props || !this.props.project) {
            return (<div></div>);
        }

        return (
            <div>
                <div className="expansion-internal-wrapper">
                    <MaterialTable
                        title=""
                        columns={this.state.columns}
                        data={this.state.products}
                        editable={{
                            onRowDelete: oldData =>
                                new Promise(resolve => {
                                    this.deleteProduct(oldData, resolve);
                                }),
                        }}
                        actions={[
                            {
                                icon: 'add',
                                tooltip: 'Добавить продукт',
                                isFreeAction: true,
                                onClick: (event) => this.setState({ "isAddProductOpen": true, "rowData": {} })
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Редактировать',
                                isFreeAction: false,
                                onClick: (event, rowData) => {
                                    console.log(rowData); this.setState({ "isAddProductOpen": true, "rowData": rowData })
                                }
                            }
                        ]}
                        options={{
                            actionsColumnIndex: -1
                        }}
                    />
                </div>
                <Dialog
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.state.isAddProductOpen}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        Добавление нового продукта
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography>
                            <TextField required
                                id="standard-required"
                                label="Продукт"
                                fullWidth
                                margin="normal"
                                value={this.state.rowData.productName}
                                onChange={this.handleRowDataChange('productName')} />
                        </Typography>
                        <Typography>
                            <TextField required
                                id="standard-required"
                                label="Версия продукта"
                                fullWidth
                                margin="normal"
                                value={this.state.rowData.productVersion}
                                onChange={this.handleRowDataChange('productVersion')} />
                        </Typography>
                        <Typography>
                            <TextField
                                id="standard-select-currency"
                                select
                                label="Тип SQL"
                                value={this.state.rowData.sqlTypeId}
                                onChange={this.handleRowDataChange('sqlTypeId')}
                                helperText=""
                                margin="normal"
                                fullWidth
                            >
                                <MenuItem key="EFBB6CEF-094D-427D-9B1B-94D1E636D88F" value="EFBB6CEF-094D-427D-9B1B-94D1E636D88F">
                                    MSSQL
                                </MenuItem>
                                <MenuItem key="92AD9E7C-CB8D-4EB3-B225-4F021981D769" value="92AD9E7C-CB8D-4EB3-B225-4F021981D769">
                                    PostGre
                                </MenuItem>
                            </TextField>
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
});

export default ProjectProducts;